/* global google */
export function init(config) {
	const { data, element, actions, onSelect, includeFbStoreId } = config;

	if (!data?.length) {
		return;
	}

	const header = [
		'_id',
		'Link',
		'Name',
		'Descriptor',
		'StoreId',
		'Street',
		'Zip',
		'City',
		'Country',
		'Location'
	];
	if (actions) {
		header.push('Actions');
	}

	let fbStoreIdPos = 0;
	if (includeFbStoreId) {
		fbStoreIdPos = header.findIndex(n => n === 'StoreId');
		header.splice(fbStoreIdPos, 0, 'FacebookStoreId');
	}

	function genDataTable() {
		const gdata = new google.visualization.DataTable();

		header.forEach(n => {
			gdata.addColumn('string', n);
		});
		gdata.addRows(
			data.map(row => {
				const address = row.address || {};
				const rowDesc = [
					row._id,
					row.link,
					row.name,
					row.locationDescriptor,
					row.storeId,
					address.street,
					address.zip,
					address.city,
					address.country,
					row.location ? `${row.location.lat},${row.location.lon}` : ''
				];
				if (actions) {
					rowDesc.push('Connect');
				}
				if (includeFbStoreId) {
					rowDesc.splice(fbStoreIdPos, 0, row.fbStoreId);
				}
				return rowDesc;
			})
		);

		return gdata;
	}
	function patternFormat(gdata, tpl, sources = [''], dest = '') {
		const linkFormatter = new google.visualization.PatternFormat(tpl);

		linkFormatter.format(
			gdata,
			sources.map(s => header.findIndex(x => x === s)),
			header.findIndex(x => x === dest)
		);
	}

	function drawVisualization() {
		const gdata = genDataTable();
		patternFormat(gdata, `<a href="{0}" target="_blank">{1}</a>`, ['Link', 'Name'], 'Name');
		patternFormat(
			gdata,
			`<a href="https://maps.google.com/maps?q={0}" target="_blank">{0}</a>`,
			['Location'],
			'Location'
		);

		if (actions) {
			const tpl = actions.map(
				action =>
					`<button style="color:white;font-weight:600;margin-bottom:10px" class="pmt-btn pmt-btn--default datatable-action-${action.id} datatable-action--${action.id}">${action.text}</button>`
			);

			patternFormat(gdata, tpl.join(''), ['Actions'], 'Actions');
		}
		const container = typeof element === 'string' ? document.querySelector(element) : element;
		const gtable = new google.visualization.Table(container);
		const gview = new google.visualization.DataView(gdata);
		gview.hideColumns([0, 1]);

		gtable.draw(gview, {
			allowHtml: true,
			width: '100%',
			height: gdata.getNumberOfRows() > 8 ? '320px' : '100%',
			alternatingRowStyle: true,
			showRowNumber: true
		});

		if (onSelect) {
			google.visualization.events.addListener(gtable, 'select', function () {
				const current = gtable.getSelection()[0];
				onSelect(current ? data[current.row] : null);
			});
		}

		if (actions) {
			actions.map(action => {
				container.addEventListener('click', evt => {
					if (evt.target.classList.contains(`datatable-action-${action.id}`)) {
						const current = gtable.getSelection()[0];
						action.onClick(data[current.row]);
						gtable.setSelection(); // deselect;
					}
				});
			});
		}
	}
	function downloadAsCsv(filename) {
		function download(content) {
			const contentType = 'text/csv';
			const a = document.createElement('a');
			const blob = new Blob([content], { type: contentType });
			a.href = window.URL.createObjectURL(blob);
			a.download = filename;
			a.click();
		}
		const gdata = genDataTable();
		let csv = header.map(n => JSON.stringify(n)).join(',') + '\n';
		csv += google.visualization.dataTableToCsv(gdata);
		download(csv);
	}

	function loadScript(cb) {
		if (window.google?.charts) {
			cb();
			return;
		}
		const body = document.getElementsByTagName('body')[0];
		const script = document.createElement('script');
		script.type = 'text/javascript';
		script.onload = cb;
		script.src = 'https://www.gstatic.com/charts/loader.js';
		body.appendChild(script);
	}

	loadScript(function () {
		google.charts.load('current', { packages: ['table'] });
		google.charts.setOnLoadCallback(drawVisualization);
	});

	return {
		downloadAsCsv
	};
}
